import * as constants from '../constants';

export default function (state = [], action) {
  switch (action.type) {
    case constants.GET_ITEMS_SUCCESS:
    case constants.GET_ITEMS_BY_PROVIDER_ID_SUCCESS:
    case constants.GET_ITEM_BY_ID_SUCCESS:
      return Object.assign({},
        state, {
          items: action.items,
          isRefreshRequired: false,
        });
    case constants.POST_ITEM_SUCCESS:
      return Object.assign({},
        state, {
          newId: action.newId,
          isRefreshRequired: true,
        });
    case constants.GET_ITEMS_ERROR:
    case constants.GET_ITEMS_BY_PROVIDER_ID_ERROR:
    case constants.GET_ITEM_BY_ID_ERROR:
    case constants.POST_ITEM_ERROR:
    case constants.PATCH_ITEM_ERROR:
      return {
        error: action.error,
      };
    case constants.BULK_DELETE_ITEMS_ERROR:
      return {
        error: action.error,
        bulkDeleteInProgress: false
      };
    case constants.BULK_DELETE_ITEMS_SUCCESS:
      return Object.assign({}, state, {
        isRefreshRequired: true,
        bulkDeleteInProgress: false
      });
    case constants.BULK_DELETE_ITEMS_INPROGRESS:
      return Object.assign({}, state, {
        bulkDeleteInProgress: true
      });
    case constants.ITEMS_SCROLL_POS:
      return Object.assign({}, state, {
        scrollPos: action.scrollPos
      });
    case constants.PATCH_ITEM_SUCCESS:
        return Object.assign({}, state, {
            isRefreshRequired: true,
          });
    case constants.GET_NOT_ACTIVE_ITEMS_SUCCESS:
        return Object.assign({}, state, {
          notActiveItems: action.items
        });
    default:
        return state;
  }
};
